import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "book-reading__content-editor" }
const _hoisted_2 = {
  key: 0,
  class: "thread-edit__row"
}
const _hoisted_3 = { class: "thread-edit__row" }
const _hoisted_4 = { class: "thread-edit__row" }
const _hoisted_5 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_6 = {
  type: "submit",
  class: "btns"
}

import { computed, onMounted, ref } from 'vue'
import { useWait } from '@/app/composables/useWait'
import { useRouter } from 'vue-router'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'

import DocLayout from '@/app/components/doc/Layout.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

import UsernameInput from './UsernameInput.vue'

import { ValidationState } from '@/helpers/form'
import { auth } from '@/services/auth'
import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { ThreadView } from '@/models/forum'
import { setInputFocusStart } from '@/helpers/form'
import type { DocView } from '@/models/doc'
import type { ThreadWithAuthor } from '@/models/interfaces'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'ThreadEdit',
  props: {
    doc: {}
  },
  setup(__props: any) {

const EMPTY_THREAD: Partial<ThreadWithAuthor> = { title: '', text: '' }

const props = __props

const router = useRouter()
const wait = useWait()

const inputRef = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const threadUrlSlug = ref<string | null>(null)

const isLoading = ref(false)
const validation = ref(new ValidationState())
const model = ref({ ...EMPTY_THREAD })

onMounted(() => {
  // Retrieve the threadUrlSlug from the history api state
  threadUrlSlug.value = window.history.state.threadUrlSlug
  const threadTitle = window.history.state.threadTitle
  const threadText = window.history.state.threadText
  const userWorkoutId = window.history.state.userWorkoutId

  if (!threadUrlSlug.value) {
    // The component was pre-filled with the exercise content,
    // put the cursor at the start of the text
    setInputFocusStart(inputRef.value?.$el)
  } else {
    loadThread()
  }
  if (threadTitle) {
    model.value.title = threadTitle
  }
  if (threadText) {
    model.value.text = threadText
  }
  if (userWorkoutId) {
    model.value.user_workout_id = userWorkoutId
  }
})

const hasUsername = computed(() => {
  return !!auth.getUsername()
})

async function save(): Promise<void> {
  try {
    if (!model.value) {
      throw new Error('Can not save thread, no model')
    }
    wait.start('Posting')
    const thread = await backend.saveThread(props.doc, model.value)
    validation.value.reset()
    router.push({
      name: props.doc.routeNames().thread,
      params: { thread: thread.url_slug },
    })
  } catch (error) {
    validation.value.showErrors(error)
  } finally {
    wait.end('Posting')
  }
}

async function loadThread(): Promise<void> {
  try {
    isLoading.value = true
    const response = await backend.getThread(assertNotNull(threadUrlSlug.value))
    model.value = new ThreadView(response, props.doc)
    isLoading.value = false
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      // Redirect to the non-existing page
      router.push({ name: 'not_found' })
    } else {
      Sentry.captureException(error)
      throw error
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (!isLoading.value)
    ? (_openBlock(), _createBlock(DocLayout, {
        key: 0,
        doc: __props.doc,
        "show-text-controls": false
      }, {
        "page-title": _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("h1", { class: "title-section__title" }, "Create a new discussion post", -1)
        ]))]),
        "page-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("form", {
              class: "form thread-edit",
              role: "form",
              novalidate: "",
              onSubmit: _withModifiers(save, ["prevent"])
            }, [
              (!hasUsername.value)
                ? (_openBlock(), _createElementBlock("fieldset", _hoisted_2, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "form__label form__label--large" }, "Username", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                    _createVNode(UsernameInput, {
                      model: model.value,
                      validation: validation.value
                    }, null, 8, ["model", "validation"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("fieldset", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "form__label form__label--large" }, "Title", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form__label form__label--sub" }, "To get more help, write a descriptive title (like what type of situation you're dealing with).", -1)),
                _createVNode(InputWithContextMenu, {
                  id: "tread-edit-title",
                  modelValue: model.value.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.title) = $event)),
                  class: _normalizeClass(["form-control", validation.value.stateClass('title')]),
                  placeholder: "Enter title here",
                  type: "text"
                }, null, 8, ["modelValue", "class"]),
                _createVNode(FormError, {
                  errors: validation.value.errors,
                  field: "title"
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("fieldset", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form__label form__label--large" }, "Body", -1)),
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                _createVNode(InputWithContextMenu, {
                  id: "tread-edit-text",
                  ref_key: "inputRef",
                  ref: inputRef,
                  modelValue: model.value.text,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.text) = $event)),
                  elementType: "textarea",
                  class: _normalizeClass(["form-control", validation.value.stateClass('text')]),
                  placeholder: "Enter post body here",
                  rows: "8",
                  type: "text"
                }, null, 8, ["modelValue", "class"]),
                _createVNode(FormError, {
                  errors: validation.value.errors,
                  field: "text"
                }, null, 8, ["errors"])
              ]),
              (validation.value.errors && validation.value.errors._schema)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " {validation.errors._schema} "))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_6, [
                _createVNode(_component_v_wait, { for: "Posting" }, {
                  waiting: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createTextVNode(" Posting ", -1)),
                    _createVNode(ButtonSpinner)
                  ]),
                  default: _withCtx(() => [
                    _cache[11] || (_cache[11] = _createTextVNode(" Post for Discussion ", -1))
                  ]),
                  _: 1
                })
              ])), [
                [_directive_wait, 'Posting', "disabled"]
              ])
            ], 32)
          ])
        ]),
        _: 1
      }, 8, ["doc"]))
    : _createCommentVNode("", true)
}
}

})